import React from "react";
import { Table } from "antd";
import styled from "@emotion/styled";

import { getColumns } from "./Columns";

export default ({ data, role, handleGenCode = () => {} }) => {
  const columns = getColumns({ role, handleGenCode });

  return (
    <TableContent>
      <Table columns={columns} dataSource={data} size="small" bordered />
    </TableContent>
  );
};

const TableContent = styled.div`
  max-width: 650px;
  width: 100%;

  table {
    border: 1px solid !important;
    border-radius: 8px 8px 0 0;
  }

  table > thead > tr > th {
    font-size: 12px;

    &:first-child {
      border-radius: 8px 0 0 0 !important;
    }

    &:nth-last-child(1) {
      border-radius: 0 8px 0 0 !important;
    }
  }
`;
